export const environment = {
  production: true,
  apiUrl: 'https://yashaswipayslip-001-site4.mtempurl.com/api/'
  //apiUrl: 'http://yashaswipayslip-001-site2.mtempurl.com/api/'
  //apiUrl: 'https://localhost:44386/api/'
};

